"use client";
import React, { useState } from "react";
import "./customerSupport.css";
import { Box, Button, InputAdornment, TextField, styled } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PhonePausedIcon from "@mui/icons-material/PhonePaused";
import { Facebook, Twitter, Instagram, LinkedIn } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MessageIcon from "@mui/icons-material/Message";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

export const CustomerSupport = () => {
  // const [selectedValue, setSelectedValue] = React.useState("");
  // const [responseObject, setResponseObject] = useState(new ResponseObject());
  const [values, setValues] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  // useEffect(() => {
  //   getCustomerDetails();
  // }, []);

  // useEffect(() => {
  //   console.log("value changed");
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     gender: responseObject.object?.gender ?? "",
  //     name: responseObject.object?.name ?? "",
  //     email: responseObject.object?.workEmail ?? "",
  //     mobile: responseObject.object?.mobile ?? "",
  //     message: responseObject.object?.dob ?? "",
  //   }));
  //   setSelectedValue(responseObject.object?.gender ?? "");
  // }, [responseObject]);

  // useEffect(() => {
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     gender: selectedValue,
  //   }));
  // }, [selectedValue]);

  const handleDetails = (e: any) => {
    const { name, value } = e.target;
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log("--submit");
    // const customerUpdateRequest = new CustomerUpdateRequest();
    // customerUpdateRequest.name = values.name;
    // customerUpdateRequest.workEmail = values.email;
    // customerUpdateRequest.dob = values.message;
    // customerUpdateRequest.gender = values.gender;
    // console.log(customerUpdateRequest);
    // handleLoginCloseAfterSignUp();
    // apiService
    //   .post(
    //     apiService.updateCustomerDetails,
    //     customerUpdateRequest,
    //     getToken()!
    //   )
    //   .then((value) => {
    //     alert(value?.message);
    //     getCustomerDetails();
    //   });
  };

  const StyledTextField = styled(TextField)({
    "& .MuiInputAdornment-positionStart": {
      marginRight: "5px",
      color: "white",
    },
    // "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "white",
      color: "white",
    },
    // },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white", // Change this to the desired outline color
      },
      "&:hover fieldset": {
        borderColor: "white", // Change this to the desired hover outline color
      },
      "&.Mui-focused fieldset": {
        borderColor: "white", // outline color when focused
      },
      "& .MuiInputLabel-root": {
        color: "white", // Change this to the desired label color
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "blue", // Change this to the desired focused label color
      },
    },
  });

  return (
    <Box>
      {/* <Box className="container"> */}
      {/* <span className="big-circle"></span> */}
      {/* <img src="img/shape.png" className="square" alt="" /> */}
      <Box className="form">
        <Box className="contact-info">
          <h3 className="title">Let&#39;s get in touch</h3>
          <p className="text">
            If you have any query or issue. Fill the form below and our service
            representative will connect with you soon.
          </p>

          <Box className="info">
            <Box className="information">
              <LocationOnIcon /> &nbsp; &nbsp;
              <p>B-23, Sector-64, Noida, India</p>
            </Box>

            <Box className="information">
              <EmailIcon />
              &nbsp; &nbsp;
              <p>info@salontym.com</p>
            </Box>
            <Box className="information">
              <PhonePausedIcon />
              &nbsp; &nbsp;
              <p>+91 8510000223</p>
            </Box>
          </Box>

          <Box className="social-media">
            <p>Connect with us :</p>
            <Box className="social-icons">
              <a
                href="https://www.facebook.com/salontym/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </a>
              <a
                href="https://x.com/salontym"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter />
              </a>
              <a
                href="https://www.instagram.com/salon_tym/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </a>
              <a
                href="https://www.linkedin.com/company/salontymindia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedIn />
              </a>
            </Box>
          </Box>
          {/* <Box sx={{ marginTop: "1rem" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.031131244273!2d77.37386848751504!3d28.628829053698098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce557739486b3%3A0xa08f2a60b30c443e!2sMetro%20Station%20Noida%20Electronic%20City%2C%20H%20Block%2C%20Sector%2062%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1715671824056!5m2!1sen!2sin"
              width="100%"
              height="200"
              // style="border:0"
              style={{ border: "0px" }}
              // allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Salon_tym"
            ></iframe>
          </Box> */}
        </Box>

        <Box className="contact-form">
          <span className="circle one"></span>
          <span className="circle two"></span>

          <form>
            <h3 className="title">Contact us</h3>
            <StyledTextField
              id="input-with-icon-adornment"
              label="Name"
              required
              name="name"
              type="text"
              value={values.name}
              onChange={handleDetails}
              sx={{
                margin: "0.5rem",
                width: "100%",
                color: "white",
                input: { color: "white" },
              }}
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircleIcon style={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Mobile Number"
              required
              name="mobile"
              type="number"
              value={values.mobile}
              onChange={handleDetails}
              sx={{
                margin: "0.5rem",
                width: "100%",
                input: { color: "white" },
              }}
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LocalPhoneIcon style={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Email Id"
              name="email"
              type="email"
              value={values.email}
              onChange={handleDetails}
              sx={{
                margin: "0.5rem",
                width: "100%",
                input: { color: "white" },
              }}
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailIcon style={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
            />
            <StyledTextField
              id="input-with-icon-adornment"
              label="Message"
              required
              name="message"
              type="text"
              value={values.message}
              onChange={handleDetails}
              sx={{
                margin: "0.5rem",
                height: "5rem",
                width: "100%",
                input: { color: "white" },
                // "& input": {
                //   height: "3rem",
                //   // color: "white",
                // },
              }}
              InputLabelProps={{
                style: { color: "#fff" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MessageIcon style={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
            />
            {/* <input type="submit" value="Send" className="btn" /> */}
            <Button
              variant="contained"
              sx={{
                background: "#fff",
                width: "100%",
                margin: "1rem 0px",
                borderRadius: "14px",
                py: 1.25,
                fontWeight: 800,
                textTransform: "none",
                color: "#1f7a4d",
                boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                "&:hover": {
                  background: "rgba(255,255,255,0.95)",
                  color: "#123524",
                },
              }}
            >
              Send message
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
    // </Box>
  );
};
